import { useLingui } from '@lingui/react/macro';
import { useAtomValue } from 'jotai';

import { claimAttachmentIdAtom } from '@/modules/claims/summary/atoms';
import { cleanClaimsAttachmentValuesAtom } from '@/modules/claims/summary/state';
import { usePreferences } from '@/react-query/usePreferences';

export const ClaimHeader = () => {
  // atoms
  const attachmentId = useAtomValue(claimAttachmentIdAtom);
  const cleanClaimsAttachmentValues = useAtomValue(
    cleanClaimsAttachmentValuesAtom,
  );

  // hooks
  const { data: preferences } = usePreferences();
  const { i18n, t } = useLingui();

  const patientInfo = cleanClaimsAttachmentValues?.patientInfo;

  const appointmentDate = patientInfo?.dateOfVisit
    ? patientInfo.dateOfVisit
    : null;

  const localizedVisitDate = appointmentDate
    ? i18n.date(appointmentDate)
    : t`Unknown`;

  const InfoField = ({ label, value }: { label: string; value: string }) => (
    <div className="vai-w-full">
      <div className="vai-font-medium vai-h-6">{label}</div>
      <div>{value}</div>
    </div>
  );

  return (
    <div
      data-testid="claim-header"
      className="vai-flex vai-justify-between vai-border-b vai-border-gray-200 vai-pb-4"
    >
      <InfoField
        label={t`Patient Name`}
        value={patientInfo?.name || t`Unknown`}
      />
      {!preferences?.isProviderNameDisabledInAttachment && (
        <InfoField
          label={t`Provider Name`}
          value={patientInfo?.providerName || t`Unknown`}
        />
      )}
      <InfoField label={t`Date of Service`} value={localizedVisitDate} />
      {attachmentId && (
        <InfoField label={t`Attachment ID`} value={attachmentId} />
      )}
    </div>
  );
};
